const KHbase = {};
if (process.env.BUILD_ENV == 'development') {
    KHbase.url = 'https://devdocapi.kanghehealth.com'
    KHbase.domain = 'https://devmemapi.kanghehealth.com' // 测评接口和指导方案接口
}else if (process.env.BUILD_ENV == 'release') {
    KHbase.url = 'https://csdocapi.kanghehealth.com/'
    KHbase.domain = 'https://csmemapi.kanghehealth.com/'
} else if (process.env.BUILD_ENV == 'sit') {
    KHbase.url = 'https://sit-docapi.kanghehealth.com/'
    KHbase.domain = 'https://sit-memapi.kanghehealth.com/'
} else if (process.env.BUILD_ENV == 'pre') {
    KHbase.url = 'https://pre-docapi.kanghehealth.com/'
    KHbase.domain = 'https://pre-memapi.kanghehealth.com/'
} else if (process.env.BUILD_ENV == 'production') {
    KHbase.url = 'https://docapi.kanghehealth.com/'
    KHbase.domain = 'https://memapi.kanghehealth.com/' // 测评接口和指导方案接口
}

export default KHbase;



// WEBPACK FOOTER //
// ./src/kanghe.config.js